// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1324":"3b25391f","3471":"3b25391f","5027":"5377c777","5289":"60402d65","7560":"217a90d5","7850":"081051b4","8272":"53978d44"}[chunkId] + ".chunk.css";
};